import { render, staticRenderFns } from "./CercaPratiche.vue?vue&type=template&id=304647ec&scoped=true&"
import script from "./CercaPratiche.vue?vue&type=script&lang=js&"
export * from "./CercaPratiche.vue?vue&type=script&lang=js&"
import style0 from "./CercaPratiche.vue?vue&type=style&index=0&id=304647ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304647ec",
  null
  
)

export default component.exports